import { Coordinates } from '@/types/commons/commons.types';

export enum FatoTypeEnum {
  LANDING = 'LANDING',
  TAKE_OFF = 'TAKE_OFF',
  HYBRID = 'HYBRID',
  CONTINGENCY = 'CONTINGENCY',
}

export enum FatoStateEnum {
  NOMINAL = 'NOMINAL',
  CONTINGENCY = 'CONTINGENCY',
  INOPERABLE = 'INOPERABLE',
}

export interface Fato {
  code: string;
  number: number;
  type: FatoTypeEnum;
  state: FatoStateEnum | null;
  position: Coordinates;
}

export interface Vertiport {
  id: string;
  site: string;
  code: string;
  name: string;
  fatos: Fato[];
}

export interface Flight {
  id: string;
  site: string;
  aircraftId: string;
  aircraftType: string;
  departure: string;
  arrival: string;
  reroutedArrival: string | null;
  currentArrivalBooked: boolean;
}
